import { RefreshCw, Calendar, Receipt } from 'lucide-react';
import { useBillingUsage } from '../../../api/hooks/useBilling';

export function UsageTab() {
  const { data: usage, isLoading } = useBillingUsage();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        <RefreshCw className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  const publishedInvites = usage?.usage?.published_invites ?? 0;
  const paidInvites = usage?.usage?.paid_invites ?? [];

  return (
    <div className="max-w-4xl">
      {/* Stats */}
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        {/* Published Invites */}
        <div className="bg-background-card border border-border rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
              <Calendar className="w-7 h-7" />
            </div>
          </div>
          <h3 className="text-base font-semibold text-text-primary mb-1">Published Invites</h3>
          <p className="text-xs text-text-secondary mb-4">Currently live</p>
          <span className="text-3xl font-bold text-text-primary">{publishedInvites}</span>
        </div>

        {/* Purchased Invites */}
        <div className="bg-background-card border border-border rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="w-14 h-14 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
              <Receipt className="w-7 h-7" />
            </div>
          </div>
          <h3 className="text-base font-semibold text-text-primary mb-1">Purchased Invites</h3>
          <p className="text-xs text-text-secondary mb-4">Total paid invites</p>
          <span className="text-3xl font-bold text-text-primary">{paidInvites.length}</span>
        </div>
      </div>

    </div>
  );
}
